export default {

    setSessionStatus(state, status) {
        state.sessionStatus = status;
    },

}